export default "__VITE_ASSET__IAFszvYd__"